// extracted by mini-css-extract-plugin
export var select = "_pu-0";